<template>
	<div v-if="installmentPrice || (installmentMinPrice && item.installments_calculation?.regular)" class="cd-installment-price-container">
		<div
			class="cd-installment-price"
			:class="{'el-loyalty': isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.basic_price_custom, 'el-discount': (item?.discount_percent_custom && (item?.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)) && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))}">
			<div v-html="labels.get('installments_price_text').replace('%PRICE%', formatCurrency(installmentPrice))"></div>
		</div>
		<div class="cd-installments-calculate" :class="{'special': installmentPrice}" @click="flyoutInstallments(item.installments_list_data, item.installments_calculation)">
			<span class="cd-installments-calculate-label cd-flyout-btn"><BaseCmsLabel code="installments_calculate" /></span>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const {formatCurrency} = useCurrency();
	const auth = useAuth();
	const {emit} = useEventBus();
	const props = defineProps(['item']);

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});

	//installments
	const installmentPrice = computed(() => {
		if (props.item?.installments_calculation && props.item?.installments_calculation?.regular) {
			const values = Object.values(props.item.installments_calculation.regular);
			return Math.min(...values);
		}
		if(isLoyalty.value == true && props.item?.installments_calculation && props.item?.installments_calculation?.loyalty) {
			const values = Object.values(props.item.installments_calculation.loyalty);
			return Math.min(...values);
		}
		if (props.item?.installments_calculation && props.item?.installments_calculation?.regular) {
			const values = Object.values(props.item.installments_calculation.regular);
			installmentMinPrice.value = Math.min(...values);
		}
	});
	const installmentMinPrice = computed(() => {
		if (props.item?.installments_calculation && props.item?.installments_calculation?.regular) {
			const values = Object.values(props.item.installments_calculation.regular);
			return Math.min(...values);
		}
	});

	//flyout installments
	function flyoutInstallments(content_list, content_calculation) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		const content = {
			installment_list: content_list,
			installment_calculation: content_calculation
		};
		emit('flyoutUpdate', {'flyout_mode': 'installments', 'flyout_title': labels.get('installments_flyout_title'), 'flyout_content': content ? content : null});
	}
</script>

<style lang="less" scoped>
	.cd-installment-price-container{
		display: flex; align-items: center; margin-top: 10px;

		@media (max-width: @m){margin-top: 15px;}
	}
	.cd-installment-price{
		display: block; flex-shrink: 0; font-size: 15px; line-height: 1.2; font-weight: normal; padding: 0;
		&.el-discount :deep(span){color: @red;}
		&.el-loyalty :deep(span){color: @blue;}
		:deep(p){padding-bottom: 0;}
		:deep(span){font-weight: 600;}
	}
	.cd-installments-calculate{
		display: flex; align-items: center; flex-shrink: 0; margin: 0; position: relative;
		&.special{
			margin-left: 9px; padding-left: 9px;
			&:before{.pseudo(1px,11px); background: @borderColor; position: absolute; left: 0; bottom: 2px;}
		}

		@media (max-width: @m){
			&.special{margin-left: 7px; padding-left: 7px;}
		}
	}
	.cd-installments-calculate-label{
		padding: 0 15px 0 20px; font-size: 14px; line-height: 1.2; font-weight: 600; color: @blue; text-decoration: none; position: relative; cursor: pointer;
		&:before{.icon-calculator(); font: 15px/15px @fonti; color: @blue; position: absolute; top: 1px; left: 0;}
		&:after{.icon-arrow-down(); font: 8px/8px @fonti; font-weight: 600; color: @blue; position: absolute; top: 4px; right: 0; .rotate(-90deg); .transition(right);}
		@media (min-width: @t){
			&:hover{
				text-decoration: underline;
				&:after{right: -5px;}
			}
		}

		@media (max-width: @m){
			&:after{top: 5px;}
		}
	}
</style>
